// Local User
// Local Storage
// User

export enum LocalStorageConstant {
  USER_DETAILS = "user_details",
  USER_AUTH = 'auth',
  USER_ID = 'user_id',
  USER_SIGN_IN = 'user_sign_in',
  USER_SIGN_OUT = 'user_sign_out',
  USER_ACCESS_TOKEN = 'user_access_token',
  INVITATION_PROGRESS = 'invitation_progress',
  USER_ADDRESS = 'user_address',
  USER_IS_REDIRECT_TO_CART = 'user_redirect_to_cart',
  USER_IS_AUTHENTICATED = 'user_is_authenticated',
  LAST_ACTION_URL = 'LAST_ACTION_URL',

  USER_USERNAME = 'username',
  USER_USER_SIGNUP_CONFIRMED = 'user_signup_confirmed',

  USER_IS_REMEMBER_ME = 'user_is_remember_me',

  USER_NO_REMEMBER_ME = 'user_no_remember_me',
  SELECTED_PLAN = 'SELECTED_PLAN',
  SELECTED_FEATURE = "SELECTED_FEATURE"
}

